(() => {
  const initializeCarousel = (carousel) => {
    if (typeof Swiper === "undefined" || carousel.swiper) return;

    new Swiper(carousel, {
      loop: carousel.querySelectorAll(".swiper-slide").length > 1,
      navigation: {
        nextEl: carousel.querySelector("[data-btn-next]"),
        prevEl: carousel.querySelector("[data-btn-prev]"),
      },
      pagination: {
        el: carousel.querySelector("[data-pagination]"),
        clickable: true,
      },
    });
  };

  const initializeCustomBento = (bento) => {
    if (bento.dataset.customBentoInitialized === "true") return;

    const images = Array.from(bento.querySelectorAll("[data-custom-bento-mobile] [data-custom-bento-image]"));
    const requestedBottomTiles = Number(bento.dataset.requestedBottomTiles) || 0;
    const bottomTileCount = Math.min(requestedBottomTiles, Math.max(images.length - 1, 0));
    const mainImageCount = images.length - bottomTileCount;
    const desktopWrapper = bento.querySelector("[data-custom-bento-desktop] .swiper-wrapper");
    const bottomRow = bento.querySelector("[data-custom-bento-bottom]");
    const cloneImage = (image) => image.cloneNode(true);

    desktopWrapper.replaceChildren(...images.slice(0, mainImageCount).map(cloneImage));
    bottomRow.replaceChildren(
      ...images.slice(mainImageCount).map((image) => {
        const tile = cloneImage(image);
        tile.className = `rounded-2xl ${bottomTileCount === 1 ? "w-full" : "w-1/2"} aspect-square overflow-hidden`;
        return tile;
      }),
    );

    bento.dataset.customBentoInitialized = "true";

    bento.querySelector("[data-custom-bento-mobile]").hidden = images.length === 0;
    bento.querySelector("[data-custom-bento-desktop]").hidden = images.length === 0;
    bottomRow.hidden = bottomTileCount === 0;

    bento.querySelectorAll(".custom-bento-media").forEach(initializeCarousel);
  };

  const initializeCustomBentos = (root = document) => {
    root.querySelectorAll("[data-custom-bento]").forEach(initializeCustomBento);
  };

  initializeCustomBentos();

  if (!window.customBentoSectionListener) {
    window.customBentoSectionListener = true;
    document.addEventListener("shopify:section:load", (event) => initializeCustomBentos(event.target));
    document.addEventListener("custom-bento:refresh", (event) => {
      const bento = event.target;
      if (!bento.matches("[data-custom-bento]")) return;
      bento.dataset.customBentoInitialized = "false";
      initializeCustomBento(bento);
    });
  }
})();
